





















































































import Vue from "vue";
import { mapState } from "vuex";

// vue components
import InstalledSoftwaresTable from "./InstalledSoftwaresTable.vue";
import MachinePropsList from "@/components/PropsLists/MachinePropsList.vue";
import EditSchedule from "@/views/App/ServiceAndUpdates/ScheduleConfiguration/EditSchedule.vue";
import InstallationNotification from "./InstallationNotification.vue";

// model
import { UpdatePackages as UpdatePackagesRoute } from "@/router/routes";
import { InstallationUpdate } from "@/model/data/updates/InstallationUpdate";
import { Machine } from "@/model/data/Machine";
import { UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";
import { cashTypeEnumLabel } from "@/model/data/enums/CashTypeEnum";
import { getImageFromModel_200 } from "@/utility/Constants";

export default Vue.extend({
    components: {
        InstalledSoftwaresTable,
        MachinePropsList,
        EditSchedule,
        InstallationNotification,
    },
    data() {
        return {
            isLoading: false,
            UpdatePackagesRoute,
            caosBackendDialog: false,
            tabComponent: null,
            showScheduleDialog: false,
        };
    },
    props: {
        installation: { type: Object as () => InstallationUpdate },
    },
    computed: {
        ...mapState({
            configuration: (state: any) => state.configuration,
        }),
        installationIsUpToDate() {
            return this.installation.isUpToDate();
        },

        tabs() {
            var res = [];
            res.push({ id: "installationInfo", name: this.$t("common.installationInfo") });
            this.installation.machines.forEach((machine: Machine) => {
                var machineTabTitle = machine.model;
                if (machine.model != machine.serialNumber) machineTabTitle += " | " + machine.serialNumber;
                res.push({ id: machine.serialNumber, name: machineTabTitle });
            });

            return res;
        },
        caosBackendAddress() {
            return (this.installation as InstallationUpdate).getBackendAddress();
        },
    },
    methods: {
        cashTypeEnumLabel,
        getImageFromModel_200,
        onEditScheduleClose() {
            this.showScheduleDialog = false;
            this.$emit("force-reload");
        },
    },
});
